import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';
import * as ReactDOM from 'react-dom';

import LayoutContainerBlock from './layout/LayoutContainerBlock';
import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';

import { IWidget } from '../ts/Interfaces';

declare var require;
const hammer = require('hammer');

function getCurrentWidgetId(widgets: IWidget[], currentWidgetId: number): number {
    if (widgets != null && widgets.length > 0) {
        return currentWidgetId != null ? currentWidgetId : widgets[0].id;
    }
    return null;
}

function getCurrentWidgetIndex(widgets: IWidget[], currentWidgetId: number): number {
    for (let i = 0; i < widgets.length; i++) {
        const obj = widgets[i];
        const widgetId = obj.id || obj.cid;

        if (widgetId === currentWidgetId) {
            return i;
        }
    }
}

function getWidgetIdOnNavigateLeft(widgets: IWidget[], currentWidgetId: number): number {
    currentWidgetId = getCurrentWidgetId(widgets, currentWidgetId);
    if (currentWidgetId == null) {
        return;
    }

    let index = getCurrentWidgetIndex(widgets, currentWidgetId);
    if (index == null) {
        return;
    }

    index -= 1;

    if (index < 0) {
        index = widgets.length - 1;
    }

    const navObj = widgets[index];
    return navObj.id || navObj.cid;
}

function getWidgetIdOnNavigateRight(widgets: IWidget[], currentWidgetId: number): number {
    currentWidgetId = getCurrentWidgetId(widgets, currentWidgetId);
    if (currentWidgetId == null) {
        return;
    }

    let index = getCurrentWidgetIndex(widgets, currentWidgetId);
    if (index == null) {
        return;
    }

    index += 1;

    if (index >= widgets.length) {
        index = 0;
    }

    const navObj = widgets[index];
    return navObj.id || navObj.cid;
}

export default class LayoutCarousel extends React.Component<
    {
        widgets: IWidget[];
        viewportWidth: number;
        viewportHeight: number;
        hidden: boolean;
        displayMode: string;
        currentWidgetId: number;
        distractFree?: boolean;
        onChange(widgetId: number);
        onSpecialAction(key);
        children?: React.ReactNode;
    },
    {}
> {
    private static mc;

    private refs: {
        container?: HTMLDivElement | null;
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        var container = this.refs.container;

        const mc = (LayoutCarousel.mc = new hammer.Manager(container, {}));

        mc.add(
            new hammer.Swipe({
                direction: hammer.DIRECTION_HORIZONTAL,
                velocity: 0.1
            })
        );

        mc.on('swipeleft', this.handleNavigateRight);
        mc.on('swiperight', this.handleNavigateLeft);
    }

    componentWillUnmount() {
        if (LayoutCarousel.mc == null) {
            return;
        }

        LayoutCarousel.mc.off('swipeleft');
        LayoutCarousel.mc.off('swiperight');

        LayoutCarousel.mc.destroy();

        LayoutCarousel.mc = null;
    }

    handleSpecialAction = (key) => {
        var self = this;

        return function (e) {
            if (typeof self.props.onSpecialAction === 'function') {
                self.props.onSpecialAction(key);
            }
        };
    };

    processOnChange(widgetId: number) {
        if (this.props.onChange != null) {
            this.props.onChange(widgetId);
        }
    }

    handleNavigateLeft = () => {
        const widgetId = getWidgetIdOnNavigateLeft(this.props.widgets, this.props.currentWidgetId);
        this.processOnChange(widgetId);
    };

    handleNavigateRight = () => {
        const widgetId = getWidgetIdOnNavigateRight(this.props.widgets, this.props.currentWidgetId);
        this.processOnChange(widgetId);
    };

    getIndicators = (currentWidgetId) => {
        if (this.props.distractFree === true) {
            var self = this;

            var indicators = _.map(this.props.widgets, (obj, i) => {
                var key = obj.id || obj.cid;

                var _class = 'fa fa-circle' + (key !== currentWidgetId ? '-o' : '');

                return <li key={i} className={_class} onClick={() => self.processOnChange(key)}></li>;
            });

            return <ul className="layout-carousel-indicators">{indicators}</ul>;
        }
    };

    render() {
        const currentWidgetId = getCurrentWidgetId(this.props.widgets, this.props.currentWidgetId);

        var indicators = this.getIndicators(currentWidgetId);
        var indicatorgap = 0;

        return (
            <div
                ref={(el: HTMLDivElement | null) => {
                    this.refs.container = el;
                }}
                className={'layout-container layout-container-carousel' + ' mode-' + this.props.displayMode}
            >
                <div className="inner-layout-container">
                    {_.map(
                        this.props.widgets,
                        (obj, i) => {
                            const style = {
                                top: 0,
                                left: 0,

                                width: this.props.viewportWidth,
                                height: this.props.viewportHeight - indicatorgap
                            };

                            const cell = {
                                width: this.props.viewportWidth,
                                height: this.props.viewportHeight - indicatorgap
                            };

                            const widgetId = obj.id || obj.cid;

                            return (
                                <LayoutContainerBlock
                                    key={i}
                                    orderIndex={i}
                                    style={style}
                                    cell={cell}
                                    dragAllowed={false}
                                    stack={true}
                                    hidden={this.props.hidden || widgetId !== currentWidgetId}
                                    onSpecialAction={this.handleSpecialAction(widgetId)}
                                >
                                    {this.props.children[i]}
                                </LayoutContainerBlock>
                            );
                        },
                        this
                    )}
                </div>

                {indicators}
            </div>
        );
    }
}

export class LayoutCarouselNavigation extends React.Component<
    {
        widgets: IWidget[];
        currentWidgetId: number;
        viewportWidth?: number;
        viewportHeight?: number;

        onChange(widgetId: number);
    },
    {
        references: {
            widgetDisplaySelect?: HTMLSelectElement;
        };
        isOpen: boolean;
        left: string;
        maxHeight: string;
    }
> {
    private refs: {
        dropdown_menu?: HTMLDivElement | null;
        dropdown?: HTMLDivElement | null;
    };

    constructor(props) {
        super(props);

        this.state = {
            references: {},
            isOpen: false,
            left: '0',
            maxHeight: ''
        };
    }

    componentDidMount() {
        document.body.addEventListener('click', this.toggleClose);
    }

    componentWillUnmount() {
        document.body.removeEventListener('click', this.toggleClose);
    }

    componentDidUpdate(prevProps, prevState) {
        var left = '0';
        var maxHeight = '';

        if (
            this.state.isOpen == true &&
            (prevState.isOpen != this.state.isOpen ||
                this.props.viewportHeight != prevProps.viewportHeight ||
                this.props.viewportWidth != prevProps.viewportWidth)
        ) {
            const dropdown_menu = this.refs.dropdown_menu as HTMLElement;
            const dropdown = this.refs.dropdown as HTMLElement;
            if (dropdown_menu && dropdown) {
                left = dropdown.clientLeft - (dropdown_menu.clientWidth / 2 - dropdown.clientWidth / 2) + 'px';
                //dropdown_menu.style.left = (-(dropdown_menu.clientWidth / 2 - dropdown.clientWidth / 2)).toString() + 'px';
                maxHeight = this.props.viewportHeight - 20 + 'px';
            }

            this.setState({
                left: left,
                maxHeight: maxHeight
            });
        }
    }

    processOnChange(widgetId: number) {
        if (this.props.onChange != null) {
            this.props.onChange(widgetId);
        }
    }

    handleWidgetSwitch = (value) => {
        //const widgetId = this.state.references.widgetDisplaySelect.value;
        const widgetId = value; //e.target.value;
        this.processOnChange(parseInt(widgetId));
    };

    getCurrentWidgetName = (widgets: IWidget[], currentWidgetId: number): string => {
        for (let i = 0; i < widgets.length; i++) {
            const obj = widgets[i];
            const widgetId = obj.id || obj.cid;

            if (widgetId === currentWidgetId) {
                return this.getWidgetTitle(obj);
            }
        }
    };

    getWidgetTitle = (obj) => {
        if (obj.values[obj.type].name) {
            return obj.values[obj.type].name;
        } else {
            const constr = WidgetBase.getConstructorByName(obj.type);
            return constr._name;
        }
    };

    toggleOpen = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };

    toggleClose = (event) => {
        if (this.refs.dropdown_menu) {
            var isExist = false;
            var dropdown_menu = this.refs.dropdown_menu as HTMLElement;
            var dropdown = this.refs.dropdown as HTMLElement;
            _.map(dropdown_menu.children, (child, i) => {
                _.map(child.children, (h4, i) => {
                    if (h4 == event.target) {
                        isExist = true;
                    }
                });
            });
            _.map(dropdown.children, (child, i) => {
                if (child == event.target) {
                    isExist = true;
                }
            });
            if (isExist == false && dropdown != event.target) {
                this.setState({ isOpen: false });
            }
        }
    };

    render() {
        let currentWidgetId: number;
        if (this.props.currentWidgetId != null) {
            currentWidgetId = this.props.currentWidgetId;
        } else if (this.props.widgets != null && this.props.widgets.length > 0) {
            currentWidgetId = this.props.widgets[0].id;
        }
        const is_widgets = this.props.widgets.length > 1;
        const menu_btn_className = 'font-weight-bold' + (is_widgets == true ? ' dropdown-toggle' : '');
        const menu_className = 'dropdown-menu' + (this.state.isOpen == true ? ' show' : '');
        const style: any = {
            left: this.state.left,
            maxWidth: this.props.viewportWidth - 20 + 'px',
            maxHeight: this.state.maxHeight,
            overflowY: 'auto',
            textOverflow: 'ellipsis'
        };
        const dropdownStyle: any = {
            maxWidth: this.props.viewportWidth - 37 * 2 - 20 + 'px',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
        };
        var menuItems =
            is_widgets == true ? (
                <div
                    ref={(el: HTMLDivElement | null) => {
                        this.refs.dropdown_menu = el;
                    }}
                    style={style}
                    className={menu_className}
                >
                    {_.map(this.props.widgets, (obj, i) => {
                        //const key = obj.id || obj.cid;
                        let menu_item_className = 'dropdown-item';
                        if (currentWidgetId == obj.id) {
                            menu_item_className = menu_item_className + ' active';
                        }
                        var title = this.getWidgetTitle(obj);
                        return (
                            <div
                                className={menu_item_className}
                                key={i}
                                onClick={() => this.handleWidgetSwitch(obj.id)}
                            >
                                <h4
                                    style={{
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden'
                                    }}
                                >
                                    {title}
                                </h4>
                            </div>
                        );
                    })}
                </div>
            ) : null;
        var content =
            is_widgets == true ? (
                <div className="inner-single d-flex justify-content-center align-items-center ">
                    <div className="inner d-flex justify-content-center  align-items-center">
                        <div
                            ref={(el: HTMLDivElement | null) => {
                                this.refs.dropdown = el;
                            }}
                            className="dropdown"
                            style={{ position: 'absolute', display: 'flex' }}
                            onClick={this.toggleOpen}
                        >
                            <div className="font-weight-bold" style={dropdownStyle}>
                                {this.getCurrentWidgetName(this.props.widgets, currentWidgetId)}
                            </div>
                            <div className={menu_btn_className}> </div>
                            {menuItems}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="d-flex justify-content-center align-items-center font-weight-bold inner-single">
                    <div>{this.getWidgetTitle(this.props.widgets[0])}</div>
                </div>
            );

        return <div className="layout-carousel-navigation">{content}</div>;
    }
}
